import { createSelector } from 'reselect';
import { getStudioSlice } from './page';

export const getBatchAction = createSelector([getStudioSlice], state => state.batchAction);

export const getRunningBatches = createSelector(
  [getStudioSlice],
  state => state.runningBatches || []
);

export const getRunningBatchById = createSelector(
  [getRunningBatches, (runningBatches, batchId: number) => batchId],
  (runningBatches, batchId) => runningBatches.find(batch => batch.batchId === batchId)
);

export const getRunningBatchCount = createSelector(
  [getRunningBatches],
  runningBatches => runningBatches.length
);
